export default "__VITE_ASSET__Bdehl8y5__"